import { Component, OnInit, Input, Output, EventEmitter, signal } from '@angular/core';
import { SortService } from '@app/components/sorting/SortService';
import { InstitutionType } from '@app/models/institution';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MemberService } from '@app/services/member.service';
import { Listbox } from 'primeng/listbox';

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
  institutionTypeId: number;
}

interface District {
  id: number;
  shortName: string;
  name: string;
  seat: string;
}

@Component({
  selector: 'app-institution-chooser',
  templateUrl: './institution-chooser.component.html'
})

export class InstitutionChooserComponent implements OnInit {
  @Input() selectedinstitutions;
  @Input() form;
  @Output() institutionSelected = new EventEmitter();
  institutionlist: Institution[] = [];
  institutionbydistrictlist: Institution[] = [];
  districtlist: District[] = [];
  institutiontypes: InstitutionType[] = [];
  filterIsOn: boolean = false;

  constructor(
    private institutionService: InstitutionsService,
    private memberService: MemberService) { }

  ngOnInit() {
    this.getInstitutionTypes();
    this.getAllDistricts();
    this.getAllInstitutions();
  }

  getInstitutionTypes() {
    this.institutionService.getInstitutionTypes().subscribe(data => {
      this.institutiontypes = data;
      const removelist = ['AV', 'AVGBREV', 'UT', 'EL', 'ELA', 'K', 'RLK', 'RR', 'SOFT', 'BD', 'RD'];
      this.institutiontypes = this.institutiontypes.filter(x => {
        return removelist.indexOf(x.prefix) === -1;
      });
    });
  }

  onChangeInstitutionType(event: any) {
    this.form.patchValue({ parentInstitutionId: null });
    this.filterAndCheckInstitutionListByType(event.target.value);
    this.filterIsOn = true;
    this.form.get('institutionTypeId').disable();
  }

  removeSelectedInstitution(id: number) {
    const idx = this.selectedinstitutions.findIndex(x => x.id === id);
   // this.selectedinstitutions.splice(idx, 1);
   // this.institutionSelected.emit(this.selectedinstitutions);

    this.selectedinstitutions = [...this.selectedinstitutions.filter(i => i.id !== id)];
  }

  updateInstitutionList(event: any) {
    if (this.filterIsOn) {
      this.getAllInstitutions();
      this.filterIsOn = false;
    } else {
      this.form.get('institutionTypeId').disable();
      this.institutionService.GetInstitutionChildren(Number(event.target.value)).subscribe(response => {
        this.institutionbydistrictlist = response;
        this.institutionbydistrictlist = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
        this.institutionbydistrictlist.forEach(x => {
          x.name = x.shortName + ' ' + x.name;
        });
        const templist = [];
        this.institutionbydistrictlist.forEach(x => {
          const idx = this.institutionlist.findIndex(i => i.id === x.id);
          templist.push(this.institutionlist[idx]);
        });
        this.institutionbydistrictlist = templist;
      });
    }
  }

  getAllDistricts() {
    this.memberService.getAllDistricts(0).subscribe(response => {
      this.districtlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
    });
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
    });
  }

  filterAndCheckInstitutionListByType(type: number) {
    this.institutionlist = this.institutionlist.filter(i => i.institutionTypeId === +type);
    this.form.get('parentInstitutionId').disable();
  }

  updateSelectedInstitutions(evt) {
    this.institutionSelected.emit(this.selectedinstitutions);
 
  }

  clearFilter(listbox: Listbox) {
    listbox._filterValue = signal('');
    this.form.get('institutionTypeId').enable();
    this.form.patchValue({parentInstitutionId: null});
    this.institutionbydistrictlist = [];
    if (this.filterIsOn) {
      this.getAllInstitutions();
      this.form.patchValue({ institutionTypeId: null });
      this.filterIsOn = false;
      this.form.get('parentInstitutionId').enable();
    }
  }
}
